import { useCallback, useEffect, useState } from 'react';
import { useRuntimeSetting } from 'shared/hooks';
import { setCookie } from '@cian/utils/lib/browser/cookie';

const COOKIE_NAME = 'newbuilding_mortgage_payment_filter_onboarding';

export const useOnboarding = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isOnboardingEnabled = useRuntimeSetting('Newbuilding.MortgageMonthlyPaymentOnboarding.Enabled', false);

  useEffect(() => {
    const hasOnboardingCookie = document.cookie.includes(`${COOKIE_NAME}=1`);

    if (isOnboardingEnabled && !hasOnboardingCookie) {
      setIsOpen(true);
      setCookie(COOKIE_NAME, '1', { domain: '.cian.ru' });
    }
  }, [isOnboardingEnabled]);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    onClose,
  };
};
